import React, { useState, useRef } from "react";
import WmModals from "../modals/Wm.Modals";
import API_ENDPOINT from "../wm.api.service";
import axios from "axios";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import { decode } from "base-64";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dummy from "../assets/images/file.svg"
import Moment from "react-moment";
import Cookies from "universal-cookie";
import { useMutation, useQueryClient, } from "react-query";
import { getSinglePortfolioDetail, updateEducationData } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
import { ExclamationIcon } from "@heroicons/react/outline";
import Spinner from "../Components/spinner/Spinner";
const Cookie = new Cookies();
function Educationcard({ educationData }) {
  const queryClient = useQueryClient()
  var token = Cookie.get("wmtoken");
  const [editModal, setEditModal] = React.useState(false);
  const [portfolioData, setPortfolioData] = useState({ institute: '', course_title: '', board: '', start_date: new Date(), end_date: new Date(), grade: '', grade_privacyBool: true, grade_privacy: true, media_privacyBool: true, media_privacy: 0, mediaSend: '', media: dummy });
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const imageDelete = () => {
    setPortfolioData((prevData) => {
      prevData.media = ''
      prevData.mediaSend = ''
      return { ...prevData }
    })
  };
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteFeild = (e, id) => {
    setIsDeleting(true);
    e.preventDefault();
    var fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("field_name", "EDUCATION");
    fd.append("field_id", id);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
      data: fd,
    })
      .then(function () {
        setIsDeleting(false);
        setEditModal(false);
        setIsDeleteModalOpen(false);
        queryClient.invalidateQueries('educationData')
      })
      .catch(function (err) {
        setIsDeleting(false);
        alert(err.response.data.validation_error.replace(/(<([^>]+)>)/gi, ""));
      });
  };
  const [deleteModal, setIsDeleteModalOpen] = useState(false);

  const fetchSingleData = useMutation((documentId) => getSinglePortfolioDetail('EDUCATION', documentId), {
    onSuccess: (data) => {
      setPortfolioData({
        identity: data.identity, institute: data.institute_name, course_title: data.course_title, board: data.board, start_date: data.start_date, end_date: data.end_date, grade: data.grade, grade_privacy: data.grade_privacy === '1' ? true : false, media_privacy: data.media_privacy === '1' ? true : false, mediaSend: data.education_media && data.education_media, media: data.education_media
      })
      setEditModal(true);
    },
  })
  const updateEducation = useMutation((data) => updateEducationData(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('educationData')
      const previousValue = queryClient.getQueriesData('educationData')
      return previousValue
    },
    onError: (err, previousValue) => {
      queryClient.setQueryData('educationData', previousValue)
    },
    onSuccess: () => {
      queryClient.invalidateQueries('educationData')
      setEditModal(false)
    }
  })
  return (
    <React.Fragment>
      {fetchSingleData.isLoading ? ("Fetching Data.....") : (
        <div className="educationCard shadow space-y-1 relative p-6 cursor-pointer" onClick={(e) => fetchSingleData.mutate(educationData.identity)}>
          <div className="flex items-center justify-between">
            <span className="text-base md:text-xl text-gray-700 inline-block capitalize" style={{"color":"var(--color-5)"}}>{educationData.course_title}</span>
            <span className="text-xs italic text-gray-600"><Moment format={"YYYY"}>{educationData.start_date}</Moment> - <Moment format={"YYYY"}>{educationData.end_date}</Moment></span>
          </div>
          <div className="">
            <span className="wm-m-none font-semibold text-base md:text-lg color-5 wm-flex-5 manpro leading-6">{educationData.institute_name} </span>
            <span className="text-xs text-gray-600 italic">- {educationData.board}</span>
          </div>
          <div className="flex justify-between">
            <div>{educationData.grade_privacy === "1" ? educationData.grade && (<span className="wm-flex-5">Grade: {educationData.grade}</span>) : ""}</div>
            {educationData.media_privacy === "1" ? (educationData.education_media === null ? ("") : (
              <div className="media_wrapper border border-gray-200 rounded-md w-24 h-24">
                <img src={educationData.education_media} alt="media" className="w-24 h-24 object-cover" />
              </div>)) : ("")}
          </div>
        </div>
      )}
      {/* EDIT MODAL */}
      <WmModals show={editModal} onHide={() => setEditModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Edit Education Detail</h5>
        {updateEducation.isError ? <><div><ServerError message={updateEducation.error.response.status} /> <div className="text-center manpro mt-4"><Wmbutton label="Cancel" onClick={() => setEditModal(false)} className="rounded w-20 mr-2" type="button" color="primary" /></div> </div></>
          : <form onSubmit={(e) => { e.preventDefault(); updateEducation.mutate(portfolioData) }}>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Institute Name <Required /></label>
              <input placeholder="Institute Name" type="text" name="institute" className="wm_form_input border-bottom border-gray-300" value={portfolioData.institute} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.institute = e.target.value; return { ...prevData } }) }} />
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Course Name <Required /></label>
              <input placeholder="Course Name" type="text" name="course_title" className="wm_form_input border-bottom border-gray-300" value={portfolioData.course_title} required onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.course_title = e.target.value; return { ...prevData } }) }} />
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Board/University <Required /></label>
              <input placeholder="Board/University" type="text" name="board" className="wm_form_input border-bottom border-gray-300" value={portfolioData.board} required onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.board = e.target.value; return { ...prevData } }) }} />
            </div>
            <Row>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Start Date <Required /></label>
                  <DatePicker selected={new Date(portfolioData.start_date)} onChange={(date) => { setPortfolioData((prevData) => { prevData.start_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                </div>
              </Col>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">End Date <Required /></label>
                  <DatePicker selected={new Date(portfolioData.end_date)} onChange={(date) => { setPortfolioData((prevData) => { prevData.end_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                </div>
              </Col>
              <Col md={7}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Grade/Percentage</label>
                  <input placeholder="Grade/Percentage" type="text" name="grade" className="wm_form_input border-bottom border-gray-300" value={portfolioData.grade} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.grade = e.target.value; return { ...prevData } }) }} />
                </div>
              </Col>
              <Col md={5}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Show Grade</label>
                  <Wmswitch color="success" checked={portfolioData.grade_privacy} onChange={() => setPortfolioData((prevData) => { prevData.grade_privacy = !portfolioData.grade_privacy; return { ...prevData } })} />
                </div>
              </Col>
              <Col md={7}>
                <div className="wm_form_group flex mb-4 items-center">
                  <div className="flex flex-col mr-4">
                    <label className="wm_form_label">Media</label>
                    <input type="file" name="grade" className="hidden" ref={fileUpload} accept="image/png, image/jpeg, image/jpg" onChange={(e) => uploadImage(e)} />
                    <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                      {portfolioData.media ? (<img className="object-cover" src={portfolioData.media} alt="education" />) : (<img className="object-cover" src={dummy} alt="education" />)}
                    </div>
                  </div>
                  <div>
                    <div>
                      <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right"><HelpIcon /></Tooltip>
                    </div>
                    <div>
                      {portfolioData.media && (<DeleteForeverIcon className="cursor-pointer" onClick={() => imageDelete("DELETE")} />)}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={5}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Show Media</label>
                  <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })} />
                </div>
              </Col>
            </Row>
            <div className="wm_form_group">
              <Wmbutton label={updateEducation.isLoading ? (<CircularProgress className="loader_size_xsm" />) : ("Update")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border" />
              <Wmbutton label="Cancel" onClick={() => setEditModal(false)} className="rounded w-20 mr-2" type="button" color="primary" />
              <Wmbutton label="Delete" onClick={(e) => { setIsDeleteModalOpen(true); setEditModal(false); }} className="rounded w-20" type="button" color="danger" />
            </div>
          </form>}
      </WmModals>
      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <div className='px-10 py-4'>
          <div>
            <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Education?</p>
            <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
              <div className='flex space-x-3 p-4'>
                <div>
                  <ExclamationIcon className='w-6 text-red-600' />
                </div>
                <div>
                  <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>Are you sure you want to delete?</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>You can't undo this action.</p>
                </div>
              </div>
            </div>
            <div className='text-center space-x-3 flex justify-center'>
              <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => { setIsDeleteModalOpen(false); setEditModal(true); }}>Cancel</button>
              {isDeleting ? <div className='relative flex items-center justify-center'><Spinner className="" width={20} height={20} /></div> : <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={(e) => { deleteFeild(e, educationData.identity); }}>Delete education</button>}
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}
export default Educationcard;
